import { render } from "./EventDetails.vue?vue&type=template&id=c919d89c&scoped=true"
const script = {}

import "./EventDetails.vue?vue&type=style&index=0&id=c919d89c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c919d89c"]])

export default __exports__